import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { AttendeeDto } from '../dto/attendee.dto';
import {
  QueryResult,
  QueryOptions,
  QueryResultItem,
} from '../components/common-dto/query.dto';

@Injectable({
  providedIn: 'root',
})
export class MockAttendeeService {
  private mockAttendees: QueryResultItem<AttendeeDto>[] = [
    {
      id: '1',
      item: {
        firstName: 'John',
        lastName: 'Smith',
        email: 'john.smith@example.com',
        company: 'Tech Solutions Inc.',
        title: 'Software Engineer',
        phone: '402-555-0101',
        createdAt: new Date('2024-12-01'),
        updatedAt: new Date('2024-12-01'),
      },
    },
    {
      id: '2',
      item: {
        firstName: 'Sarah',
        lastName: 'Johnson',
        email: 'sarah.johnson@example.com',
        company: 'Digital Marketing Pro',
        title: 'Marketing Director',
        phone: '402-555-0102',
        createdAt: new Date('2024-12-02'),
        updatedAt: new Date('2024-12-02'),
      },
    },
    {
      id: '3',
      item: {
        firstName: 'Michael',
        lastName: 'Williams',
        email: 'michael.williams@example.com',
        company: 'Cloud Services LLC',
        title: 'Cloud Architect',
        phone: '402-555-0103',
        createdAt: new Date('2024-12-03'),
        updatedAt: new Date('2024-12-03'),
      },
    },
    {
      id: '4',
      item: {
        firstName: 'Emily',
        lastName: 'Brown',
        email: 'emily.brown@example.com',
        company: 'Data Analytics Co.',
        title: 'Data Scientist',
        phone: '402-555-0104',
        createdAt: new Date('2024-12-04'),
        updatedAt: new Date('2024-12-04'),
      },
    },
    {
      id: '5',
      item: {
        firstName: 'David',
        lastName: 'Jones',
        email: 'david.jones@example.com',
        company: 'Startup Ventures',
        title: 'CEO',
        phone: '402-555-0105',
        createdAt: new Date('2024-12-05'),
        updatedAt: new Date('2024-12-05'),
      },
    },
    {
      id: '6',
      item: {
        firstName: 'Jessica',
        lastName: 'Garcia',
        email: 'jessica.garcia@example.com',
        company: 'Design Studio',
        title: 'UX Designer',
        phone: '402-555-0106',
        createdAt: new Date('2024-12-06'),
        updatedAt: new Date('2024-12-06'),
      },
    },
    {
      id: '7',
      item: {
        firstName: 'Robert',
        lastName: 'Miller',
        email: 'robert.miller@example.com',
        company: 'Finance Group',
        title: 'Financial Analyst',
        phone: '402-555-0107',
        createdAt: new Date('2024-12-07'),
        updatedAt: new Date('2024-12-07'),
      },
    },
    {
      id: '8',
      item: {
        firstName: 'Amanda',
        lastName: 'Davis',
        email: 'amanda.davis@example.com',
        company: 'Education Solutions',
        title: 'Education Specialist',
        phone: '402-555-0108',
        createdAt: new Date('2024-12-08'),
        updatedAt: new Date('2024-12-08'),
      },
    },
  ];

  constructor() {}

  getAttendees(
    conferenceId: string,
    queryParams: QueryOptions
  ): Observable<QueryResult<AttendeeDto>> {
    let items = [...this.mockAttendees];

    // Apply filter if provided
    if (queryParams.filter && queryParams.filter.trim() !== '') {
      const filterLower = queryParams.filter.toLowerCase();
      items = items.filter(
        (attendee) =>
          attendee.item.firstName?.toLowerCase().includes(filterLower) ||
          attendee.item.lastName?.toLowerCase().includes(filterLower) ||
          attendee.item.email?.toLowerCase().includes(filterLower) ||
          attendee.item.company?.toLowerCase().includes(filterLower) ||
          attendee.item.title?.toLowerCase().includes(filterLower)
      );
    }

    // Apply pagination
    if (queryParams.take && queryParams.skip !== undefined) {
      const skip = Number(queryParams.skip);
      const take = Number(queryParams.take);
      items = items.slice(skip, skip + take);
    }

    return of({
      items,
      total: this.mockAttendees.length,
      take: queryParams.take || items.length,
      skip: queryParams.skip || 0,
    }).pipe(delay(300));
  }
}

